import { render, staticRenderFns } from "./yuceOccupy.vue?vue&type=template&id=8aabd840"
import script from "./yuceOccupy.vue?vue&type=script&lang=js"
export * from "./yuceOccupy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports